import React, { Component } from 'react';
import { BarChart, Bar, Brush, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts';

export default class Weather extends Component {
    static displayName = Weather.name;

    constructor(props) {
        super(props);
        this.state = {
            startDate: props.startDate,
            endDate: props.endDate,
            step: props.step,
            data: []
        }
    }

    componentDidMount() {
        var startDate = this.state.startDate.substring(0, this.state.startDate.indexOf("T"));
        var endDate = this.state.endDate.substring(0, this.state.endDate.indexOf("T"))
        var url = "https://www.ncdc.noaa.gov/cdo-web/api/v2/data/?stationid=GHCND:USC00441593&datasetid=GSOM&startdate=" + startDate + "&enddate=" + endDate + "&limit=1000&units=standard&datatypeid=TAVG";
        fetch(url, {
            headers: {
                "token": "qlMriszvuVjiiGUYHANGubJFBFXiVUuu"
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            this.setState({ data: data.results });
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                startDate: prevProps.startDate,
                endDate: prevProps.startDate,
                step: prevProps.step
            }, () => {
                if (this.state.step === "month") {
                    var startDate = this.state.startDate.substring(0, this.state.startDate.indexOf("T"));
                    var endDate = this.state.endDate.substring(0, this.state.endDate.indexOf("T"))

                    var url = "https://www.ncdc.noaa.gov/cdo-web/api/v2/data/?stationid=GHCND:USC00441593&datasetid=GSOM&startdate=" + startDate + "&enddate=" + endDate + "&limit=1000&units=standard&datatypeid=TAVG";
                    fetch(url, {
                        headers: {
                            "token": "qlMriszvuVjiiGUYHANGubJFBFXiVUuu"
                        }
                    })
                    .then(response => response.json())
                    .then(data => {
                        console.log(data);
                        this.setState({data: data.results})
                    });
                }
            });
        }
    }
    render() {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        var step = this.state.step;
        var data = [];
        this.state.data.forEach(function (item) {
            var date = item.date;
            var newDate = new Date(Date.parse(date));
            var dateString = ""
            if (step === "month") {
                dateString = monthNames[newDate.getMonth()] + ", " + newDate.getFullYear();
                data.push({
                    'Date': dateString,
                    'Avg. Temp': item.value
                });
            } 
        });
        return (
            
            <div style={{ width: '100%', height: 300 }}>
                <ResponsiveContainer>
                    <BarChart
                        width={700}
                        height={300}
                        data={data}
                        margin={{
                            top: 5, right: 30, left: 20, bottom: 5
                        }}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="Date" />
                        <YAxis />
                        <Tooltip />
                        <Brush dataKey="Date" height={30} stroke="#7d83ff" />
                        <Bar dataKey="Avg. Temp" fill="#a95c90" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/Weather.js